import { Helmet } from "react-helmet";
import PageHeader from "../../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import { useNavigate } from "react-router-dom";
import SearchIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Members/Search.svg";
import DatePicker from "../../../../../components/Universal/DatePicker.component";
import DropDownInput from "../../../../../components/Universal/DropDownInput.component";
import CashInFlowTable from "../../../../../components/PagesComponents/Financial/CashInFlow/Dashboard/CashInFlowTable.component";
import "../../../../../styles/Pages/Financial/CashInFlow/Dashboard/CashInFlowSheet.style.css";

const Body = () => {
  const headers = [
    "Receipt id/Time",
    "Type of income",
    "Linked to corespondence",
    "Equivalent amount(INR)",
    "Paid by (someone/B2B)",
    "Confirmed By",
    "Receipts",
  ];
  const data = [
    {
      receiptId: "23457289056",
      incomeType: "Fees",
      correspondentLink: "",
      amount: 18000.0,
      paidBy: "Muktesur coaching",
      phoneNumber: "9876543210",
      confirmedby: "Jaheer Ahmad",
      date: "27 Dec 2024",
      time: "10:24 AM",
    },
    {
      receiptId: "23457289056",
      incomeType: "Grants",
      correspondentLink: "",
      amount: 18000.0,
      paidBy: "Mohit Enterprise",
      phoneNumber: "9876543210",
      confirmedby: "Jaheer Ahmad",
      date: "27 Dec 2024",
      time: "10:24 AM",
    },
    {
      receiptId: "23457289056",
      incomeType: "Fees",
      correspondentLink: "",
      amount: 18000.0,
      paidBy: "Mohit Enterprise",
      phoneNumber: "9876543210",
      confirmedby: "Jaheer Ahmad",
      date: "27 Dec 2024",
      time: "10:24 AM",
    },
    {
      receiptId: "23457289056",
      incomeType: "Fees",
      correspondentLink: "",
      amount: 18000.0,
      paidBy: "Mohit Enterprise",
      phoneNumber: "9876543210",
      confirmedby: "Jaheer Ahmad",
      date: "27 Dec 2024",
      time: "10:24 AM",
    },
    {
      receiptId: "23457289056",
      incomeType: "Other grants",
      correspondentLink: "",
      amount: 18000.0,
      paidBy: "Mohit Enterprise",
      phoneNumber: "9876543210",
      confirmedby: "Jaheer Ahmad",
      date: "27 Dec 2024",
      time: "10:24 AM",
    },
    {
      receiptId: "23457289056",
      incomeType: "Fees",
      correspondentLink: "",
      amount: 18000.0,
      paidBy: "Mohit Enterprise",
      phoneNumber: "9876543210",
      confirmedby: "Jaheer Ahmad",
      date: "27 Dec 2024",
      time: "10:24 AM",
    },
    {
      receiptId: "23457289056",
      incomeType: "Other grants",
      correspondentLink: "",
      amount: 18000.0,
      paidBy: "Mohit Enterprise",
      phoneNumber: "9876543210",
      confirmedby: "Jaheer Ahmad",
      date: "27 Dec 2024",
      time: "10:24 AM",
    },
    {
      receiptId: "23457289056",
      incomeType: "Fees",
      correspondentLink: "",
      amount: 18000.0,
      paidBy: "Mohit Enterprise",
      phoneNumber: "9876543210",
      confirmedby: "Jaheer Ahmad",
      date: "27 Dec 2024",
      time: "10:24 AM",
    },
    {
      receiptId: "23457289056",
      incomeType: "Other grants",
      correspondentLink: "",
      amount: 18000.0,
      paidBy: "Mohit Enterprise",
      phoneNumber: "9876543210",
      confirmedby: "Jaheer Ahmad",
      date: "27 Dec 2024",
      time: "10:24 AM",
    },
  ];
  const navigate = useNavigate();
  return (
    <section className="cashInFlowSheetContainer">
      <Helmet>
        <title>Cash InFlow Sheet</title>
        <meta
          name="description"
          content="Monitor and analyze cash inflow trends and contributions."
        />
        <meta
          name="keywords"
          content="cash inflow, financial dashboard, cash flow analysis, business finance"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <PageHeader title={"Cash InFlow Sheet"} />
      <div className="cashInFlowSheet mt-1">
        <div className="searchBox">
          <h3>All cash inflow income history in one sheet</h3>
          <div className="inputs">
            <div className="inputBoxes">
              <div className="searchInputContainer">
                <button className="searchBtn">
                  <img src={SearchIcon} alt="Search" />
                </button>
                <input
                  type="text"
                  className="pageHeaderInput"
                  placeholder="Search receipt id"
                />
              </div>
              <DatePicker
                // label="date"
                name="datePicker"
                // setFieldValue={(val) => setFieldValue("date", val)}
                placeholder={"Choose a date"}
              />
              <DropDownInput
                type="select"
                name="chooseCategory"
                // label="category"
                // setFieldValue={(val) => {}}
                placeholder={"Choose category"}
                suggestionList={[]}
              />
            </div>
            <div className="buttons">
              <button
                className="actionBtn"
                onClick={() => navigate("/finance/cashinflow/dashboard")}
              >
                Go to cash inflow dashboard
              </button>
              <button className="actionBtn">Download</button>
            </div>
          </div>
        </div>
        <div className="tableContainer">
          <CashInFlowTable
            headers={headers}
            data={data}
            renderFooterElement={
              <div className="custom-table-footer">
                <div id="totalCount" style={{ color: "var(--rawUmber)" }}>
                  Total Count: <span style={{ color: "white" }}>236</span>
                </div>
                <div id="totalAmount">
                  Total equivalent amount:{" "}
                  <span
                    style={{
                      color: "var(--blueLagoonLight)",
                      fontWeight: "400",
                    }}
                  >
                    ₹2,60,560
                  </span>
                </div>
              </div>
            }
          />
        </div>
      </div>
    </section>
  );
};

export default Body;
